// Copy drafted by AI; reviewed and approved by the user 2026-10-14 (spec 168).
/** Each console page's answer, under its title (spec 168). */
export const CONSOLE_ANSWER_COPY = {
  overviewWords: 'spent this period',
  exact: (amount: string) => `Exact: ${amount}`,

  profilesWords: (count: number) =>
    count === 1 ? 'model profile' : 'model profiles',
  connections: (count: number) =>
    count === 1 ? '1 Claude connection' : `${count} Claude connections`,
  defaults: (names: readonly string[]) =>
    names.length === 0 ? 'no default set' : `default: ${names.join(', ')}`,

  limitsWords: (count: number) => (count === 1 ? 'workspace' : 'workspaces'),
  custom: (count: number) => `${count} with their own limits`,
  nearSpend: (count: number) => `${count} near their spend limit`,
  runFull: (count: number) => `${count} at their run limit`,

  escalationOff: 'Nobody is told when something needing action is left waiting',
  escalationOn:
    'before the workspace owner is told about something left waiting',

  generalWords: (environment: string) => `in ${environment}`,
} as const;
